import React, {Component} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import {
    SaveData,
    SetPropertyValue,
    SavePropertyValue,
    SelectAppointmentByID
} from "../../actions/TaskActions";
import { SelectedAppSelector } from "../../selectors/SelectedAppointmentSelector";

import { setTitle } from "../../actions/AppActions";
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import ShortId from 'shortid';

const styles2 = {
    card: {
        margin: "20px",
        border: "1px solid #999"
    }
};

class MaterialBestellung extends Component {
    
    state = {
        MaterialBestellungList: []
    }

    componentDidMount() {
        this.props.setTitle("Material zu bestellen");
        this.props.SelectAppointmentByID(this.props.match.params.id, this.props.match.params.service);
    }

    saveData = async () => {
        const data = {
            MaterialBestellungList: this.props.app.MaterialBestellungList
        };
        await this.props.SaveData(this.props.app, data);
    }
    handleBlur = async (e) => {
        this.saveData();
    }
    addItem = (tableName) => e => {
        e.preventDefault();
        let tableArr = this.props.app[tableName] || [];
        console.log(this.state);
        switch (tableName) {
            case "MaterialBestellungList":
                tableArr.push({ id: ShortId.generate(), Material: "", Stuck: "" });
                break;
            default:
                return tableArr;
        }
        this.setState({ tableName: tableArr });
        this.props.SetPropertyValue(this.props.app, tableName, tableArr);
    }
    deleteItem = (idToDelete, tableName) => e => {
        let changedData = this.props.app[tableName].filter(e => e.id !== idToDelete);
        this.setState({ tableName: changedData });
        this.props.SetPropertyValue(this.props.app, tableName, changedData);
    }
    handleChangeInput = (idToUpdate, tableName) => e => {
        let updatedData = this.props.app[tableName].map(d => {
            if (d.id === idToUpdate) {
                d[e.target.name] = e.target.value;
                return d;
            } else return d;
        });
        this.setState({ tableName: updatedData });
        this.props.SetPropertyValue(this.props.app, tableName, updatedData);
    }

    handleChange = (e, checked) => {
        this.props.SetPropertyValue(
            this.props.app,
            e.target.name,
            checked
        );
    };

    render() {
        if (!this.props.app.StartDate) return <div />;
        let MaterialBestellungList = this.props.app.MaterialBestellungList || [];

        return (
            <div style={{marginTop: "70px"}}>
                <Paper elevation={1} style={styles2.card}>
                <table style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <td></td>
                                <td>Material</td>
                                <td>Menge</td>
                            </tr>
                        </thead>
                        <tbody>
                            {MaterialBestellungList.map((val, idx) => {
                                return (
                                    <tr key={val.id}>
                                        <td> <Fab aria-label="Delete" onClick={this.deleteItem(val.id, "MaterialBestellungList")}>
                                            <DeleteIcon />
                                        </Fab></td>
                                        <td >
                                            <TextField
                                                name="Material"
                                                multiline
                                                fullWidth
                                                value={val.Material}
                                                onBlur={this.handleBlur}
                                                onChange={this.handleChangeInput(val.id, "MaterialBestellungList")}
                                                margin="normal"
                                            />
                                        </td>
                                        <td>
                                            <TextField
                                                name="Stuck"
                                                value={val.Stuck}
                                                onBlur={this.handleBlur}
                                                onChange={this.handleChangeInput(val.id, "MaterialBestellungList")}
                                                margin="normal"
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    <Fab color="primary" aria-label="Add" onClick={this.addItem("MaterialBestellungList")}>
                        <AddIcon />
                    </Fab>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    app: SelectedAppSelector(state),
    company: state.app.company
});

export default withRouter(
    connect(
        mapStateToProps,
        {
            SaveData,
            setTitle,
            SetPropertyValue,
            SavePropertyValue,
            SelectAppointmentByID
        }
    )(MaterialBestellung)
);